import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react';

export interface FieldProps {
  label: string;
  // `| undefined` so callers may pass `error={maybeUndefined}` under exactOptionalPropertyTypes.
  htmlFor?: string | undefined;
  hint?: string | undefined;
  error?: string | undefined;
  /** Mandatory field — shows a red «*» marker; pair with submit-gating so the user is LED to complete it.
   *  The ONE visual language for "required" across every form (R-A input discipline). */
  required?: boolean | undefined;
  /** Optional field — shows a muted «(اختیاری)» tag, so mandatory-by-default reads unambiguously. */
  optional?: boolean | undefined;
  children: ReactNode;
}

/** Label + control + optional hint/error. Wrap an <Input/> (or any control). */
export function Field({ label, htmlFor, hint, error, required, optional, children }: FieldProps) {
  return (
    <div className="field">
      <label htmlFor={htmlFor}>
        {label}
        {required ? (
          <span className="field-req" title="الزامی" aria-label="الزامی">
            {' '}
            *
          </span>
        ) : optional ? (
          <span className="field-opt"> (اختیاری)</span>
        ) : null}
      </label>
      {children}
      {hint ? <div className="field-hint">{hint}</div> : null}
      {error ? <div className="field-error">{error}</div> : null}
    </div>
  );
}

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={['input', className ?? ''].filter(Boolean).join(' ')} {...rest} />;
}

export function Textarea({ className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={['input', className ?? ''].filter(Boolean).join(' ')} {...rest} />;
}
